export default "__VITE_ASSET__HCgjpgqC__"